module.exports = require("core-js/library/fn/object/get-prototype-of");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime/core-js/object/get-prototype-of.js
// module id = 14
// module chunks = 35783957827783 114276838955818 162898551421021